/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDeloitte = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M8.079 3c.342.012.684.03 1.025.064.647.063 1.282.184 1.904.37.957.288 1.83.736 2.594 1.385a6.397 6.397 0 0 1 1.666 2.193c.296.632.493 1.295.62 1.98.162.873.206 1.754.178 2.64-.03.974-.158 1.935-.435 2.872a7.774 7.774 0 0 1-1.059 2.246 6.96 6.96 0 0 1-1.81 1.802 7.791 7.791 0 0 1-2.243 1.039c-.585.168-1.181.275-1.786.338-.467.049-.937.07-1.407.07H2.083c-.027 0-.056.005-.083-.006V3.082l.002-.078.071-.002h5.644L7.78 3zM6.557 6.704c-.063-.001-.082.012-.082.079.002 1.563.002 3.126.002 4.688l-.001 4.688c0 .06.016.074.073.073.304-.003.608 0 .912-.001.5-.002.993-.051 1.473-.196.536-.162 1.008-.43 1.389-.847.34-.372.567-.809.732-1.282.231-.666.324-1.358.356-2.059a9.8 9.8 0 0 0-.1-2.035c-.084-.518-.223-1.019-.47-1.485a2.823 2.823 0 0 0-1.219-1.229c-.485-.25-1.006-.36-1.546-.384-.506-.022-1.013-.005-1.52-.01zm12.527 8.142a2.578 2.578 0 0 1 2.911 2.454c.01.064.002.128.004.191.004.613-.22 1.142-.61 1.605a2.571 2.571 0 0 1-1.448.86 2.12 2.12 0 0 1-.371.038c-.025 0-.05-.008-.073.006h-.041a.177.177 0 0 0-.11 0h-.04c-.089-.032-.182-.02-.273-.035-.81-.132-1.434-.544-1.857-1.247a2.57 2.57 0 0 1 .266-2.995 2.52 2.52 0 0 1 1.642-.877z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDeloitte as Deloitte };
